<section class="auth-page-shell">
  <div class="auth-page-bg">
    <div class="container auth-page-container">
      <div class="auth-card auth-card-signin password-change-card">
        <div class="auth-form-panel">
          <div class="auth-form-heading">
            <img
              :src="$sideLogo"
              class="img-fluid mx-auto d-block w-200 w-md-150"
              alt=""
            />
          </div>

          <h4 class="fw-bold mt-3 d-flex justify-content-center">Password Change</h4>

          <form class="auth-form" @submit.prevent="submitNewPassword">
            <div class="auth-field">
              <label for="new_password" class="form-label">
                New Password<span class="text-danger">*</span>
              </label>
              <div class="auth-field-shell">
                <i class="bi bi-lock auth-input-icon"></i>
                <input
                  :type="newPasswordVisible ? 'text' : 'password'"
                  class="form-control"
                  id="new_password"
                  placeholder="Enter new password"
                  v-model="new_password"
                  required
                />
                <button
                  type="button"
                  class="auth-eye-toggle"
                  @click="togglePasswordVisibility('new_password')"
                  aria-label="Toggle new password visibility"
                >
                  <i :class="newPasswordVisible ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                </button>
              </div>
              <span v-if="errors.new_password" class="auth-error">{{ errors.new_password }}</span>
            </div>

            <div class="auth-field">
              <label for="confirm_password" class="form-label">
                Confirm Password<span class="text-danger">*</span>
              </label>
              <div class="auth-field-shell">
                <i class="bi bi-lock-fill auth-input-icon"></i>
                <input
                  :type="confirmPasswordVisible ? 'text' : 'password'"
                  class="form-control"
                  id="confirm_password"
                  placeholder="Confirm new password"
                  v-model="confirm_password"
                  required
                />
                <button
                  type="button"
                  class="auth-eye-toggle"
                  @click="togglePasswordVisibility('confirm_password')"
                  aria-label="Toggle confirm password visibility"
                >
                  <i :class="confirmPasswordVisible ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                </button>
              </div>
              <span v-if="errors.confirm_password" class="auth-error">{{ errors.confirm_password }}</span>
            </div>

            <button
              type="submit"
              class="btn auth-submit-btn"
              :disabled="isLoading"
            >
              <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              {{ isLoading ? 'Changing password...' : 'Change Password' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

